'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _glamor = require('glamor');

var _Link = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Link');

var _Link2 = _interopRequireDefault(_Link);

var _PageTitle = require('@quixeltools/quixel-ui-library/dist/components/common/website/PageTitle');

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _Hr = require('@quixeltools/quixel-ui-library/dist/components/common/website/Hr');

var _Hr2 = _interopRequireDefault(_Hr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tos = (0, _glamor.css)({
  margin: '0 auto',
  maxWidth: '957px',
  width: '70%',
  marginBottom: '9rem'
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: '9rem'
}));

var para = (0, _glamor.css)({
  color: _css.pallets.gray_text,
  fontSize: (0, _css.unitRem)(0.875),
  lineHeight: (0, _css.unitRem)(1.2),
  marginTop: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(1),
  '& strong': {
    fontWeight: 700
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: (0, _css.unitRem)(0.7)
}));

var content = (0, _glamor.css)({
  '& h1': {
    color: _css.pallets.gray_text,
    fontSize: (0, _css.unitRem)(1.4),
    lineHeight: (0, _css.unitRem)(1.2),
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  },
  '& p': {
    color: _css.pallets.gray_text,
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  },
  '& ol': {
    counterReset: 'item'
  },
  '& ul': {
    listStyleType: 'circle',
    marginLeft: '2rem',
    color: _css.pallets.gray_text
  },
  '& li': {
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),

    ':before': {
      position: 'relative',
      color: _css.pallets.gray_text,
      // content: 'counters(item, ".")". "',
      // counterIncrement: 'item',
      fontSize: (0, _css.unitRem)(0.875),
      lineHeight: (0, _css.unitRem)(1.2),
      // left: '-2.2rem',
      // top: '3.3rem',

      '& strong': {
        fontWeight: 600
      }
    }
  },
  '& strong': {
    fontWeight: 600
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  '& h1': {
    fontSize: (0, _css.unitRem)(1.1)
  },
  '& p': {
    fontSize: (0, _css.unitRem)(0.7)
  },
  '& li': {
    ':before': {
      fontSize: (0, _css.unitRem)(0.7)
    } }
}));
var _link = (0, _glamor.css)({
  transition: 'color 0.2s ease-in-out',
  ':hover': {
    color: "#fff!important"
  }
});
var ol = (0, _glamor.css)({
  counterReset: 'item',
  '& ul': {
    counterReset: 'none'
  },
  '& ul li:before': {
    content: 'none',
    counterIncrement: 'none'
  }
});

var li = (0, _glamor.css)({
  ':before': {
    position: 'relative',
    color: _css.pallets.gray_text,
    // content: 'counters(item, ".")". "',
    // counterIncrement: 'item',
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),
    left: '-3.2rem',
    top: '3.3rem',

    '& strong': {
      fontWeight: 600
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  ':before': {
    fontSize: (0, _css.unitRem)(0.7)
  }
}));

var _hr = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3),
  marginBottom: (0, _css.unitRem)(3)
});
var privacy = (0, _glamor.css)({
  margin: '0 auto',
  maxWidth: '70%'
});

var button = (0, _glamor.css)({
  marginRight: (0, _css.unitRem)(1)
});

var refund = (0, _glamor.css)({
  margin: (0, _css.unitRem)(5) + ' auto',
  marginTop: 0,
  maxWidth: '74%'
});

var strong = (0, _glamor.css)({
  fontWeight: 600
});

var downloadButtons = (0, _glamor.css)({
  margin: (0, _css.unitRem)(2) + ' 0',
  textAlign: 'left'
});

var contactUs = (0, _glamor.css)({
  margin: '0 auto',
  marginBottom: (0, _css.unitRem)(5),
  textAlign: 'center',
  maxWidth: '74%'
});
var _col = (0, _glamor.css)({
  paddingLeft: '1.1rem',
  flexBasis: '33.3333%',
  border: '1px ' + _css.pallets.gray_text + ' solid',
  color: '' + _css.pallets.gray_text,
  '& p': {
    wordBreak: 'break-word'
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  paddingLeft: '0.7rem',
  '& p': {
    fontSize: (0, _css.unitRem)(0.01),
    lineHeight: (0, _css.unitRem)(0.7),
    '& ul': {
      fontSize: (0, _css.unitRem)(0.01),
      lineHeight: (0, _css.unitRem)(0.7),
      marginLeft: 7,
      '& li': {
        fontSize: (0, _css.unitRem)(0.01),
        lineHeight: (0, _css.unitRem)(0.7)
      }
    }
  },
  '& ul': {
    fontSize: (0, _css.unitRem)(0.01),
    lineHeight: (0, _css.unitRem)(0.7),
    marginLeft: 7,
    '& li': {
      fontSize: (0, _css.unitRem)(0.01),
      lineHeight: (0, _css.unitRem)(0.7)
    }
  }
}));
var heading = (0, _glamor.css)({
  textAlign: 'center',
  flexBasis: '33.3333%',
  border: '1px ' + _css.pallets.gray_text + ' solid',
  color: '' + _css.pallets.gray_text

}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  '& p': {
    fontSize: (0, _css.unitRem)(0.01)
  }
}));

var CookiePolicy = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CookiePolicy, _Component);

  function CookiePolicy() {
    (0, _classCallCheck3.default)(this, CookiePolicy);
    return (0, _possibleConstructorReturn3.default)(this, (CookiePolicy.__proto__ || (0, _getPrototypeOf2.default)(CookiePolicy)).call(this));
  }

  (0, _createClass3.default)(CookiePolicy, [{
    key: 'onTosQuery',
    value: function onTosQuery() {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactBox, {
        title: 'Have a query about our ToS?',
        message: 'We would be happy to provide answers regarding our Terms of Service. Leave us a note and we will get back to you soon.',
        tag: 'TermsOfService'
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        { documentTitle: 'Cookie Policy' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_components.SiteHeaderGap, null),
          _react2.default.createElement(
            'section',
            { id: 'cookie-policy', className: tos },
            _react2.default.createElement(_PageTitle2.default, { align: 'left', dateTop: true, title: "COOKIE POLICY", subTitle: "NOVEMBER 12TH 2019" }),
            _react2.default.createElement('div', { className: downloadButtons }),
            _react2.default.createElement(
              'div',
              { className: content },
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'We believe in being transparent about how we collect and use data. This policy describes what cookies we save and how we use them. We will also share how you can prevent these cookies from being stored.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'When we refer to',
                _react2.default.createElement(
                  'span',
                  {
                    className: 'Apple-converted-space' },
                  '\xA0 '
                ),
                '\u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D in this policy, we are referring to the relevant Epic entity identified for your region in the \u201CContact\u201D section of the policy below. When we talk about the \u201CServices\u201D in this policy, we are referring to our websites, software and copyright assets and other services which we have licensed to our customers.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'Please read our ',
                _react2.default.createElement(
                  'span',
                  { className: 's1' },
                  _react2.default.createElement(
                    _Link2.default,
                    { href: '/terms#privacy-policy', target: '_blank', className: _link },
                    'Privacy Policy'
                  )
                ),
                ' for more information about what personal data we collect, our processing of personal data and the purposes of our use of personal data.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'This Cookie Policy and your consent applies to the following domains: ',
                _react2.default.createElement(
                  'span',
                  {
                    className: 's2' },
                  _react2.default.createElement(
                    _Link2.default,
                    { href: '/', className: _link },
                    'www.quixel.com/'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 's3' },
                  ', '
                ),
                _react2.default.createElement(
                  'span',
                  {
                    className: 's2' },
                  _react2.default.createElement(
                    _Link2.default,
                    { href: 'https://licensing.quixel.se/', target: '_blank', className: _link },
                    'https://licensing.quixel.se/'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'Because we respect your right to privacy, you can choose to change your privacy preferences to prevent non-essential cookies from being set.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'COOKIES AND LOGS.'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'span',
                  { className: 's1' },
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Cookies.'
                  )
                ),
                ' A cookie is information a website or app places on your computer\u2019s or device\u2019s hard drive so that the website or app is able to remember your preferences and/or which pages you visited on the website/app and make your visit more efficient and enjoyable. We may use cookies to determine the number of unique users or visitors of the Service over a given period, or to remember user account details, etc. so that the need for multiple log-ins is eliminated. It may combine information collected through cookies to any personal data submitted online when using the Service to help personalize a user\u2019s access to and use of the Service. Cookies may be disabled on your computer or device by indicating this in the preferences or options menus in your browser.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'span',
                  { className: 's1' },
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Log files'
                  )
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '. '
                ),
                'Log files are files that log actions that have occurred on a website or in an app. We may collect data in the form of log files and may use such log files to gather statistics about users user habits and to assess overall activity in or regarding the Service, including how many "hits" a particular web page is getting and other navigational data. These entries are generated anonymously, and enable us to track interest in specific promotions and features, troubleshoot technical concerns, and provide users with content that may be of interest to them. Log files are used internally only, and are not associated with any particular user, computer, or browser.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'span',
                  { className: 's1' },
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Web beacons'
                  )
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '. '
                ),
                'The Service may use a variety of technical methods for tracking purposes, including \u201CWeb beacons\u201D etc. Web beacons are small pieces of data that are embedded in images on the pages of the Service. We may also use these technical methods to analyze the traffic patterns in the Service such as the frequency with which users accesses various parts of the Service etc. These technical methods may involve the transmission of information either directly to us or to another party authorized by us to collect information on our behalf. The information from use of these technical methods may be collected in a form that is personally identifiable.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'span',
                  { className: 's3' },
                  _react2.default.createElement('br', null),
                  ' '
                ),
                'To learn more about the general behavior of cookies please visit ',
                _react2.default.createElement(
                  'span',
                  { className: 's2' },
                  _react2.default.createElement(
                    _Link2.default,
                    { href: 'http://cookiepedia.co.uk/all-about-cookies', target: '_blank', className: _link },
                    'Cookiepedia - All About Cookies'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'HOW WE USE COOKIES.'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 's4' },
                  _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement('br', null),
                    ' '
                  )
                ),
                'We use cookies for a variety of reasons detailed below.'
              ),
              _react2.default.createElement(
                'ul',
                { className: 'ul1' },
                _react2.default.createElement(
                  'ul',
                  { className: 'ul1' },
                  _react2.default.createElement(
                    'li',
                    { className: 'li1' },
                    'Essential Cookies',
                    _react2.default.createElement('br', null),
                    ' These cookies are necessary for our Services to function and cannot be switched off. They are usually only set in response to actions you make which amount to a request for services, such as:'
                  ),
                  _react2.default.createElement(
                    'ul',
                    { className: 'ul1' },
                    _react2.default.createElement(
                      'li',
                      { className: 'li1' },
                      'Account Creation: we will use cookies when you create an account with us for the management of the signup process and general administration. These cookies will usually be deleted when you log out, however in some cases they may remain afterwards to remember your preferences when logged out.'
                    ),
                    _react2.default.createElement(
                      'li',
                      { className: 'li1' },
                      'Logging In: we use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.'
                    ),
                    _react2.default.createElement(
                      'li',
                      { className: 'li1' },
                      'Buying a Subscription: some cookies are essential to our e-commerce and payment modules and are used to ensure that your order is remembered between pages so that we can process it properly and calculate payouts to our affiliates.'
                    ),
                    _react2.default.createElement(
                      'li',
                      { className: 'li1' },
                      'Filling Forms: when you submit data to us through a form such as those found on contact pages or comment forms, cookies may be set to remember your user details for future correspondence.'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'ul',
                { className: 'ul1' },
                _react2.default.createElement(
                  'ul',
                  { className: 'ul1' },
                  _react2.default.createElement(
                    'li',
                    { className: 'li1' },
                    'Performance Cookies',
                    _react2.default.createElement('br', null),
                    ' We use cookies to understand your use of our Services so that we can work on new features and improvements. For instance, analytics cookies show us when you accessed our Services including which device was used for that access i.e. desktop or mobile. They help us understand how you use the site and ways in which we can improve your experience. For example, these cookies help us track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p5' },
                _react2.default.createElement('br', null),
                ' All the information collected by these cookies is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site and will not be able to monitor its performance.'
              ),
              _react2.default.createElement(
                'ul',
                { className: 'ul1' },
                _react2.default.createElement(
                  'li',
                  { className: 'li6' },
                  'Functionality Cookies',
                  _react2.default.createElement('br', null),
                  ' These cookies allow our website to remember choices you make and provide enhanced features. For instance, we may be able to provide you with news or updates relevant to the services you use. They may also be used to provide services you have requested such as viewing a video or commenting on a blog. The information these cookies collect is usually anonymized.'
                )
              ),
              _react2.default.createElement(
                'ul',
                { className: 'ul1' },
                _react2.default.createElement(
                  'ul',
                  { className: 'ul1' },
                  _react2.default.createElement(
                    'li',
                    { className: 'li1' },
                    'Targeting/advertising cookies'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p5' },
                'We use targeting/advertising cookies to determine what promotional content is more relevant and appropriate to you and your interests. This helps us improve the effectiveness of our campaigns and the quality of content presented to you.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'THIRD-PARTY COOKIES ON OUR SITE.'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p9' },
                'We may employ and grant third-party companies access to selected information to perform specific tasks on our behalf. They may also set third-party cookies in order to deliver the services they are providing. ',
                _react2.default.createElement(
                  'span',
                  { className: 's6' },
                  'Where applicable such third parties\u2019 use of cookies etc. will not be covered by this Cookie Policy. In such instances you must review such third parties\u2019 cookie policies etc.'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'These third party cookies may include:'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'div',
                  { className: (0, _glamor.css)({ fontSize: (0, _css.unitRem)(0.875), width: '126%',
                      marginLeft: '-16%',
                      display: 'flex', flexWrap: 'wrap', color: '' + _css.pallets.gray_text }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
                      fontSize: (0, _css.unitRem)(0.7),
                      marginLeft: '-12%'
                    })) },
                  _react2.default.createElement(
                    'div',
                    { className: heading },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Service'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: heading },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Description'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: heading },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Opt-out'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Google Analytics'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'To analyze visitor traffic on our site.',
                      _react2.default.createElement('br', null),
                      ' ',
                      _react2.default.createElement('br', null),
                      'View details: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { className: _link, target: '_blank', href: 'https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage' },
                        'Google Analytics Cookie Usage on Websites'
                      ),
                      '.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Opt-out: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { className: _link, target: '_blank', href: 'https://tools.google.com/dlpage/gaoptout' },
                        'Google Analytics Opt-out Browser Add-on'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Crazy Egg'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'To assess usage patterns and perform traffic analysis on our site.',
                      _react2.default.createElement('br', null),
                      ' ',
                      _react2.default.createElement('br', null),
                      'View details: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { className: _link, target: '_blank', href: 'http://www.crazyegg.com/privacy' },
                        'http://www.crazyegg.com/privacy'
                      ),
                      '.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Opt-out: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { className: _link, target: '_blank', href: 'http://www.crazyegg.com/opt-out' },
                        'http://www.crazyegg.com/opt-out'
                      ),
                      '.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Google Ads (DoubleClick) (Adwords) (AdSense)'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'To enable behavioral and targeted advertising and analytics by Google.',
                      _react2.default.createElement('br', null),
                      _react2.default.createElement('br', null),
                      'View details: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { className: _link, target: '_blank', href: 'https://safety.google/' },
                        'https://safety.google/'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Opt-out: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { className: _link, target: '_blank', href: 'https://adssettings.google.com' },
                        'https://adssettings.google.com'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Facebook Pixel'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      '            To enable behavioral advertising and analytics by Facebook.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Opt-out: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { target: '_blank', href: 'https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen', className: _link },
                        'https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Hubspot'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'We use Hubspot for marketing and CRM services which make use of cookies for the provision of their services.',
                      _react2.default.createElement('br', null),
                      _react2.default.createElement('br', null),
                      'View details: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { href: 'https://legal.hubspot.com/privacy-policy', className: _link, target: '_blank' },
                        'https://legal.hubspot.com/privacy-policy'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _col },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Opt-out: ',
                      _react2.default.createElement(
                        _Link2.default,
                        { target: '_blank', href: 'https://legal.hubspot.com/cookie-policy', className: _link },
                        'https://legal.hubspot.com/cookie-policy'
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'DISABLING COOKIES.'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'If you want to disable cookies you can adjust the settings on your browser. Following is a list of all the help pages pertaining to cookie management for different browsers',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'span',
                  { className: 's2' },
                  _react2.default.createElement(
                    _Link2.default,
                    { target: '_blank', href: 'https://support.google.com/chrome/answer/95647?hl=en-GB', className: _link },
                    'Google Chrome'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _Link2.default,
                    { target: '_blank', href: 'https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer', className: _link },
                    'Mozilla Firefox'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _Link2.default,
                    { target: '_blank', href: 'https://support.apple.com/kb/PH5042?locale=en_US', className: _link },
                    'Safari (Desktop)'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _Link2.default,
                    { target: '_blank', href: 'https://support.apple.com/en-us/HT201265', className: _link },
                    'Safari (Mobile)'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _Link2.default,
                    { target: '_blank', href: 'https://support.microsoft.com/en-us/kb/260971', className: _link },
                    'Internet Explorer'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _Link2.default,
                    { target: '_blank', href: 'http://support.google.com/ics/nexus/bin/answer.py?hl=en&answer=2425067', className: _link },
                    'Android Browser'
                  ),
                  _react2.default.createElement('br', null)
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'For other browsers, please refer to the browser\u2019s Help section.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'Be aware that disabling cookies will usually result in also disabling certain functionality and features of our site and Services. Therefore, it is recommended that you do not disable cookies.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'MORE INFORMATION.'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p1' },
                'For more information you can email us at ',
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, target: '_blank', href: 'mailto:legal@quixel.se' },
                  'legal@quixel.se'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 's7' },
                  ' or'
                )
              ),
              _react2.default.createElement(
                'p',
                { className: 'p12' },
                'If you reside in the United States of America at:'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p12' },
                'Epic Games, Inc., located at located at 620 Crossroads Blvd., Cary, NC 27518, USA.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p12' },
                'If you reside outside of the United States of America at:'
              ),
              _react2.default.createElement(
                'p',
                { className: 'p12' },
                'Epic Games International S.\xE0 r.l., a Luxembourg Soci\xE9t\xE9 \xE0 Responsibilit\xE9 Limit\xE9e, located at Atrium Business Park, 33 rue du Puits Romain, L8070 Bertrange, Grand-Duchy of Luxembourg, acting through its Swiss branch, having its principal business offices at Platz 3, 6039 Root, Switzerland.\xA0'
              )
            )
          )
        )
      );
    }
  }]);
  return CookiePolicy;
}(_react.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = CookiePolicy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/CookiePolicy/CookiePolicy.jsx
// module id = 2730
// module chunks = 0